import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { withPack, withoutPack } from '../data/megaPack';
import { useIsMobile } from '../hooks/useMediaQuery';
type Side = 'con' | 'sin';
export function Comparison() {
  const isMobile = useIsMobile();
  const [side, setSide] = useState<Side>('con');
  const items = side === 'con' ? withPack : withoutPack;
  return <section className="bg-cream-100 py-10 sm:py-20" aria-labelledby="comparativa" data-id="element-51" data-mp="1zw1vb722jf6k">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-52" data-mp="23xvs34957z1g">
        <SectionHeading eyebrow="La realidad" title="¿Cuánto cuesta NO tenerlo?" data-id="element-53" data-mp="23z6sqv7akqoc" />

        {isMobile ? <div className="mt-6" data-id="element-54" data-mp="28wgkwim2fgfv">
            <div className="grid grid-cols-2 gap-1 rounded-full bg-cream-50 p-1 ring-1 ring-ink/10" role="tablist" aria-label="Comparativa" data-id="element-55" data-mp="9jvxrqog95k9">
              {(['con', 'sin'] as Side[]).map(value => <button key={value} type="button" role="tab" aria-selected={side === value} onClick={() => setSide(value)} className={['rounded-full py-2 font-display text-[0.7rem] font-800 uppercase tracking-[0.12em] transition-colors duration-150 ease-out', side === value ? value === 'con' ? 'bg-teal-800 text-cream-50' : 'bg-ink/80 text-cream-50' : 'text-clay'].join(' ')} data-id="element-56" data-mp="1m2a7g2v3j2dx">
                  {value === 'con' ? 'Con el pack' : 'Sin el pack'}
                </button>)}
            </div>

            <AnimatePresence mode="wait" data-id="element-57" data-mp="kkrhpfspelbn">
              <motion.ul key={side} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className={['mt-3 grid gap-2 rounded-2xl p-4', side === 'con' ? 'bg-teal-800' : 'bg-cream-50 ring-1 ring-ink/8'].join(' ')} data-id="element-58" data-mp="khdgiavs0i5s">
                {items.map(item => <li key={item} className={['flex items-start gap-2 text-[0.8rem] leading-snug', side === 'con' ? 'text-cream-100/90' : 'text-ink/65'].join(' ')} data-id="element-59" data-mp="3ugozgxee2spy">
                    {side === 'con' ? <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-60" data-mp="3pinl2prwrhkt" /> : <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-ink/35" aria-hidden="true" data-id="element-61" data-mp="3gfw5qevww1nw" />}
                    {item}
                  </li>)}
              </motion.ul>
            </AnimatePresence>
          </div> : <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-62" data-mp="36qyyx9a4pemr">
            <div className="rounded-2xl bg-cream-50 p-6 ring-1 ring-ink/8 sm:p-7" data-id="element-63" data-mp="31tflucp637we">
              <h3 className="font-display text-sm font-800 uppercase tracking-[0.16em] text-clay" data-id="element-64" data-mp="3ft8be4oyji2s">
                Sin el Mega Pack
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-65" data-mp="3at2of1tmujr1">
                {withoutPack.map(item => <li key={item} className="flex items-start gap-3 text-sm text-ink/65" data-id="element-66" data-mp="3plw1yhpcgpt2">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-67" data-mp="3kli41shgiw8r" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="rounded-2xl bg-teal-800 p-6 text-cream-50 shadow-lift sm:p-7" data-id="element-68" data-mp="1rv7h0jlmxeeg">
              <h3 className="font-display text-sm font-800 uppercase tracking-[0.16em] text-gold-400" data-id="element-69" data-mp="1wuk3v4cialh1">
                Con el Mega Pack
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-70" data-mp="21o51gva6tdfp">
                {withPack.map(item => <li key={item} className="flex items-start gap-3 text-sm text-cream-100/90" data-id="element-71" data-mp="26n7xxrc3qbc2">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-72" data-mp="1dvobzzo4ej6d" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>}
      </div>
    </section>;
}